import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleCreateServiceModal } from '../../../redux/actions/servicesActions';
export const stnServicesDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createServices',
        popover: {
          title: 'Create New Service',
          description:
            'Click here to create a new service. You can define the service details, configure settings, and make it available to your users.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.downloadServices',
        popover: {
          title: 'Download Service Data',
          description:
            'Use this option to download service-related data for analysis or reporting purposes. Ensure you have the correct permissions before downloading.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.services',
        popover: {
          title: 'Manage Services',
          description:
            'This section allows you to view and manage all services. You can update details, monitor performance, and ensure everything is running smoothly.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allServicesList',
        popover: {
          title: 'All Services List',
          description:
            'Here you can view a comprehensive list of all services available within the system. Use this to manage and organize your services effectively.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.servicesMainTable',
        popover: {
          title: 'Services Overview Table',
          description:
            'This table provides a detailed overview of all services. You can sort, filter, and manage the services to keep everything organized.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleCreateServiceModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default stnServicesDriverObj;
